import React, { useEffect, useRef } from 'react';
import SEO from '../common/SEO';
import { VYCHOZI } from '../srovnavac2/obsah.js';
import { spustSrovnavac } from '../srovnavac2/srovnavac.js';
import '../srovnavac2/srovnavac.css';

const Srovnavac2Page = () => {
  const koren = useRef(null);

  useEffect(() => {
    const prvek = koren.current;
    if (!prvek) return;
    spustSrovnavac(prvek);
    return () => { prvek.innerHTML = ''; };
  }, []);

  return (
    <>
      <SEO
        title="Srovnávač LED | LightWell – kolik ušetříte na 1 m² světelného boxu"
        description="Zadejte parametry LED, které dnes používáte, a hned uvidíte cenu za 1 m² vedle LEDBARu. Záruka 5 let na všechny 24V LEDBARy."
        path="/srovnavac"
      />
      <div className="pt-32 pb-8 bg-white">
        <div className="px-4">
          <header className="max-w-[1080px] mx-auto border-b border-gray-200 pb-6 mb-2">
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900">{VYCHOZI.nadpis}</h1>
            <p className="mt-3 max-w-[64ch] text-base text-gray-700">{VYCHOZI.perex}</p>
          </header>
        </div>
        <div className="lw-srovnavac2" ref={koren} />
      </div>
    </>
  );
};

export default Srovnavac2Page;